import React, {Component} from 'react';
import Select from 'react-select';
import styles from './styles.module.scss';
import Trash from 'shared_features/svgs/trash';
import Spinner from 'shared_features/spinner';

export const selectStyles = {
    indicatorSeparator: (styles) => ({display:'none'}),
};

export default props => {
    // don't display unless at least 1 selected
    if (props.numSelected <= 0) {
        return null;
    }

    // set up team select
    let teamValue = null;
    const teams = [];
    for (var team of props.teams) {
        const option = { 
            value: team.id, 
            label: team.name,
            defaultGroupId: team.defaultGroupId 
        };
        teams.push(option);
        if (team.id === props.selectedTeamId) {
            teamValue = option;
        }
    }

    // set up group select
    let groupValue = null;
    const groups = [];
    for (var group of props.groups) {
        const option = { value: group.id, label: group.name };
        groups.push(option);
        if (group.id === props.groupId) {
            groupValue = option;
        }
    }

    // delete and done
    if (props.isUploading) {
        var del = <span className={[styles.delete, styles.disabled].join(' ')}><Trash /><span className={styles.deleteText}>Delete</span></span>;
        var done = <span className={styles.spinner}><Spinner /></span>
    } else {
        var del = <span className={styles.delete} onClick={()=>window.confirm("Are you sure?") && props.deleteSelectedAthletes()}><Trash /><span className={styles.deleteText}>Delete</span></span>;
        var done = <span className={styles.done} onClick={()=>props.saveSelectedAthletesCategories()}><span className={styles.doneText}>DONE</span><span className={styles.doneIcon}>✓</span></span>;
    }

    return (<div className={styles.container}>
        <span className={styles.selected}>{props.numSelected} Selected</span>
        <span className={styles.teamWrapper}>
            <Select
                name="team"
                className={styles.team}
                styles={selectStyles}
                value={teamValue}
                isClearable
                clearable={true}
                deleteRemoves={false}
                placeholder="Set team..."
                menuPlacement="top"
                onChange={(selectedOption)=> {
                    if (selectedOption) {
                        // When a team is selected, set the group to its default group
                        props.updateSelectedGroup(selectedOption.defaultGroupId);
                    } else {
                        // If no team is selected, use the organization's default group
                        props.updateSelectedGroup(props.defaultOrgGroupId);
                    }
                }}
                options={teams}
            />
        </span>
        <span className={styles.groupWrapper}>
            <Select
                name="group"
                className={styles.group}
                styles={selectStyles}
                value={groupValue}
                isClearable
                clearable={true}
                deleteRemoves={false}
                placeholder="Set group..."
                menuPlacement="top"
                onChange={(selectedOption)=> {
                    if (selectedOption) {
                        props.updateSelectedGroup(selectedOption.value);
                    } else {
                        // If no group is selected, use the default group of the current team
                        if (props.selectedTeamId) {
                            // Find the team in the teams array
                            const team = props.teams.find(t => t.id === props.selectedTeamId);
                            if (team && team.defaultGroupId) {
                                props.updateSelectedGroup(team.defaultGroupId);
                                return;
                            }
                        }

                        // If no team is selected or team has no default group, use the organization's default group
                        if (props.defaultOrgGroupId) {
                            props.updateSelectedGroup(props.defaultOrgGroupId);
                        } else {
                            props.updateSelectedGroup(null);
                        }
                    }
                }}
                options={groups}
            />
        </span>
        {del}
        {done}
    </div>);
};
